import React from 'react';
import { Ruler, Hammer, Truck, Globe, Award, TreeDeciduous } from 'lucide-react';

const Services: React.FC = () => {
  const services = [
    { icon: <Hammer size={32} />, title: "Furniture Manufacturing", desc: "Advanced solid wood furniture factory producing high-quality wooden products." },
    { icon: <Ruler size={32} />, title: "Turnkey Interior", desc: "Complete interior solutions from design to execution." },
    { icon: <TreeDeciduous size={32} />, title: "Restoration", desc: "Expert restoration and reproduction of classical furniture pieces." },
    { icon: <Truck size={32} />, title: "Timber Merchants", desc: "Specialists in solid teak wood selected from renewable sources." },
    { icon: <Globe size={32} />, title: "Exports & Imports", desc: "Global reach with international reputation for excellence." },
    { icon: <Award size={32} />, title: "Skill Development", desc: "Founder Member of the Furniture & Fittings Sector Skill Council under 'Skill India'." },
  ];

  return (
    <section id="services" className="py-24 px-6 bg-diwan-900 border-t border-diwan-800">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
            <span className="text-diwan-gold uppercase tracking-[0.3em] text-xs font-sans">What We Do</span>
            <h2 className="text-4xl md:text-5xl font-serif text-diwan-cream mt-4">Services & Expertise</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
            {services.map((s, i) => (
                <div key={i} className="group hover:-translate-y-2 transition-transform duration-500">
                    <div className="mb-6 text-diwan-gold opacity-70 group-hover:opacity-100 transition-opacity">
                        {s.icon}
                    </div>
                    <h3 className="text-2xl font-serif text-diwan-cream mb-4 border-b border-diwan-800 pb-4 group-hover:border-diwan-gold transition-colors inline-block">
                        {s.title}
                    </h3>
                    <p className="text-diwan-cream/60 font-sans text-sm leading-relaxed">
                        {s.desc}
                    </p>
                </div>
            ))}
        </div>
        
        <div className="mt-20 p-8 md:p-12 border border-diwan-gold/20 rounded-sm bg-gradient-to-br from-diwan-800 to-diwan-900">
            <div className="flex flex-col md:flex-row items-center justify-between gap-8">
                <div>
                    <h4 className="text-xl font-serif text-diwan-cream mb-2">Corporate Membership</h4>
                    <p className="text-diwan-cream/60 text-sm">Active members of CII (Confederation of Indian Industry) and FICCI.</p>
                </div>
                <div className="flex gap-4 opacity-50 grayscale hover:grayscale-0 transition-all duration-500">
                     <span className="border border-white/20 px-4 py-2 text-xs text-white">CII Member</span>
                     <span className="border border-white/20 px-4 py-2 text-xs text-white">FICCI Member</span>
                     <span className="border border-white/20 px-4 py-2 text-xs text-white">Skill India</span>
                </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default Services;